import type { RouteRecordRaw } from "vue-router";
import { constantRoutes } from "@/router";
import store from "@/stores";
const modules = import.meta.glob("../../views/**/**.vue");
import { getMenuList } from "@/api/permission";
const Layout = () => import("@/layout/index.vue");
import router from "@/router";
import { defineStore } from "pinia";

export const usePermissionStore = defineStore(
  "permission",
  () => {
    /** 所有路由，包括静态和动态路由 */
    const routes = ref<RouteRecordRaw[]>([]);
    //按钮权限
    const btnAuthArr = ref<string[]>([]);
    //菜单权限
    const leftMenuList = ref<any[]>([]);
    const menuList = ref<string[]>([]);
    /** 混合模式左侧菜单 */
    const mixLeftMenus = ref<RouteRecordRaw[]>([]);
    // 不需要在左侧显示的菜单 个人中心 系统设置  帮助中心 消息中心
    const hideMenus = ref<string[]>([
      "1894263132691677187",
      "1894191048087130112",
      "1894263445762924544",
      "1894263445762924545",
      "1894263445762924546",
    ]);
    const isRoutesLoaded = ref(false);

    /**
     * 生成动态路由
     */
    function generateRoutes(roleId) {
      return new Promise<RouteRecordRaw[]>((resolve, reject) => {
        getMenuList({ roleId })
          .then((res: any) => {
            console.log(res);
            setBtnAuthArr(res?.data?.holdFunctionList);
            // 整体的路由菜单
            menuList.value = res?.data?.menuNodeRespList || [];
            // 筛选出广告服务菜单
            let adsMenu: any = res?.data?.menuNodeRespList?.find(
              (item: any) =>
                item.menuId && item.menuId === "1894263445762924546",
            )?.childMenuNodeRespList;
            console.log("adsMenu", adsMenu);
            // 过滤出左侧菜单 广告服务取下一层级菜单需要特殊处理
            leftMenuList.value = res?.data?.menuNodeRespList?.filter(
              (item) => !hideMenus.value.includes(item.menuId),
            );
            // 左侧菜单排序
            leftMenuList.value = leftMenuList.value
              .concat(adsMenu)
              ?.sort((a, b) => {
                return a.sort - b.sort;
              });
            resolve(leftMenuList.value);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            isRoutesLoaded.value = true;
          });
      });
    }

    /**
     * 混合模式菜单下根据顶部菜单路径设置左侧菜单
     *
     * @param topMenuPath - 顶部菜单路径
     */
    const setMixLeftMenus = (topMenuPath: string) => {
      const matchedItem = routes.value.find(
        (item) => item.path === topMenuPath,
      );
      if (matchedItem && matchedItem.children) {
        mixLeftMenus.value = matchedItem.children;
      }
    };

    /**
     * 重置路由
     */
    const resetRouter = () => {
      // 删除动态路由，保留静态路由
      routes.value.forEach((route) => {
        if (route.name && !constantRoutes.find((r) => r.name === route.name)) {
          router.removeRoute(route.name); // 从 router 实例中移除动态路由
        }
      });

      routes.value = [];
      mixLeftMenus.value = [];
      isRoutesLoaded.value = false;
    };
    // 设置按钮权限
    function setBtnAuthArr(arr) {
      btnAuthArr.value = arr;
    }

    return {
      leftMenuList,
      menuList,
      routes,
      generateRoutes,
      mixLeftMenus,
      setMixLeftMenus,
      isRoutesLoaded,
      resetRouter,
      btnAuthArr,
      setBtnAuthArr,
    };
  },
  {
    persist: {
      storage: localStorage, // 可以是 localStorage, sessionStorage 或 window.localStorage
      pick: ["leftMenuList", "menuList", "btnAuthArr"], // 数据持久化数组
      key: "usePermissionStore", // 状态的键名
    },
  },
);

/**
 * 转换路由数据为组件
 */
const transformRoutes = (routes: any[]) => {
  const asyncRoutes: RouteRecordRaw[] = [];
  routes.forEach((route) => {
    const tmpRoute = { ...route } as RouteRecordRaw;
    // 顶级目录，替换为 Layout 组件
    if (tmpRoute.component?.toString() == "Layout") {
      tmpRoute.component = Layout;
    } else {
      // 其他菜单，根据组件路径动态加载组件
      const component = modules[`../../views/${tmpRoute.component}.vue`];
      if (component) {
        tmpRoute.component = component;
      } else {
        tmpRoute.component = modules["../../views/error-page/404.vue"];
      }
    }

    if (tmpRoute.children) {
      tmpRoute.children = transformRoutes(route.children);
    }

    asyncRoutes.push(tmpRoute);
  });

  return asyncRoutes;
};

/**
 * 在组件外使用 Pinia store 实例
 * @see https://pinia.vuejs.org/core-concepts/outside-component-usage.html
 */
export function usePermissionStoreHook() {
  return usePermissionStore(store);
}
